import { GroupedCategoryAxis } from "@/ui/organisms/Chart/Axis";
import { PeriodType } from "./periodAggregation";
import { AgGroupedCategoryAxisOptions } from "ag-charts-community";

export function getOptimalAxisConfig(
    period: PeriodType,
): AgGroupedCategoryAxisOptions {
    if (period === "yearly") {
        return GroupedCategoryAxis.singleDepth;
    }

    return GroupedCategoryAxis.doubleDepth;
}
